/**
 * The core framing shown prominently at the top of the tool. This is the
 * argument the whole assessment rests on: exporting is one growth option
 * among many, not an inevitable next step — especially for NZ brands who
 * face distance, scale, and cost barriers most other countries don't.
 */
export const EXPORT_FRAMING = {
  headline: 'Exporting is one of many growth options for NZ brands.',
  reframe:
    'Is exporting the best use of our limited capital, people, and attention right now — or is there a higher-return move closer to home?',
  insteadOf: 'Can we export?',
  betterQuestions: [
    'Can we actually make money at landed cost in this market?',
    'Can we create demand 12,000 km from home?',
    'Can we reliably supply without starving our NZ customers?',
    'Can we compete against brands already on shelf with local supply chains?',
    'Is this the highest-return use of the same time, money, and people?',
  ],
  alternatives: [
    'Winning more domestic distribution across NZ retail and food service',
    'Growing repeat purchase and loyalty with existing consumers',
    'Launching adjacent SKUs or formats for the NZ market',
    'Improving margins through operational efficiency',
    'Building brand awareness domestically before going offshore',
    'Partnering with Australian distributors as a closer first step',
  ],
} as const;
